var _path, _path2, _g, _g2, _g3, _g4, _mask, _g5, _g6, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHydrationSuccessIcon = function SvgHydrationSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2779 3.25995C15.9618 3.29255 15.6537 3.43852 15.4149 3.69867C13.0008 6.32865 7.18501 13.1472 7.05293 17.9317C6.90135 23.4224 11.1013 27.4338 16.2779 27.5294V3.25995Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2777 3.25999C16.5937 3.29261 16.9017 3.43858 17.1405 3.69871C19.5546 6.32869 25.3704 13.1472 25.5025 17.9317C25.6541 23.4224 21.4542 27.4338 16.2777 27.5294V3.25999Z",
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.16,
    cy: 21.1683,
    rx: 10.261,
    ry: 7.65019,
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2669 11.0895C9.33596 12.5669 6.6847 16.3111 7.71687 20.3183C7.8383 18.8409 7.47401 16.1896 10.2669 11.0895Z",
    fill: "#50AFF1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2603 13.0931C24.7782 16.3111 25.7618 23.5241 17.553 26.6327C20.3661 25.2768 25.446 20.6705 23.2603 13.0931Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58994 12.4186C8.58746 13.7597 6.45306 18.1856 8.29896 21.6655C8.24648 19.9745 8.90393 15.0586 9.58994 12.4186Z",
    fill: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 19,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2779 3.25995C15.9618 3.29255 15.6537 3.43852 15.4149 3.69867C13.0008 6.32865 7.18501 13.1472 7.05293 17.9317C6.90135 23.4224 11.1013 27.4338 16.2779 27.5294V3.25995Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2777 3.25999C16.5937 3.29261 16.9017 3.43858 17.1405 3.69871C19.5546 6.32869 25.3704 13.1472 25.5025 17.9317C25.6541 23.4224 21.4542 27.4338 16.2777 27.5294V3.25999Z",
    fill: "url(#paint3_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2924 13.8825C25.8103 17.1004 26.7939 24.3135 18.5851 27.4221C21.3982 26.0661 26.4781 21.4598 24.2924 13.8825Z",
    fill: "#4CA1DB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29544 24.2649C7.565 21.8171 5.77659 18.1928 8.12494 13.5534C8.52502 12.348 9.13434 11.3996 9.90259 10.8468C9.14727 11.7837 8.56385 12.6863 8.12494 13.5534C7.20497 16.3253 7.39131 20.4567 9.29544 24.2649Z",
    fill: "#4CA1DB"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3814 11.6922C22.7475 11.1975 21.2411 9.47421 20.4066 8.61581C20.7563 9.35637 21.4725 10.9191 21.5405 11.2457C21.6253 11.6538 21.948 12.2779 22.3814 11.6922Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9263 13.2035C13.9263 16.8986 10.9308 19.8941 7.23569 19.8941C3.54059 19.8941 0.545118 16.8986 0.545118 13.2035C0.545118 9.50841 3.54059 6.51294 7.23569 6.51294C10.9308 6.51294 13.9263 9.50841 13.9263 13.2035Z",
    fill: "#00A447",
    stroke: "white",
    strokeWidth: 1.09024
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92009 16.4925C5.74551 16.4928 5.57795 16.4237 5.45437 16.3004L2.82318 13.6692C2.57084 13.4079 2.57805 12.9915 2.83934 12.7391C3.09428 12.4929 3.49839 12.4929 3.75326 12.7391L5.92003 14.9046L10.7166 10.108C10.969 9.84667 11.3854 9.83945 11.6468 10.0918C11.9081 10.3441 11.9153 10.7606 11.6629 11.0219C11.6576 11.0274 11.6523 11.0328 11.6468 11.0381L6.38445 16.3004C6.26124 16.4234 6.09424 16.4924 5.92009 16.4925Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 4.97158,
    y: 10.5907,
    width: 26.3769,
    height: 21.1553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.46373,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 5.80086,
    y: 10.2868,
    width: 5.79057,
    height: 10.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.292747,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 16.382,
    y: 11.9221,
    width: 9.07692,
    height: 15.8816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.585494,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 3.11161,
    y: 11.2476,
    width: 11.6657,
    height: 11.5889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.585494,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 17.4141,
    y: 12.7115,
    width: 9.07692,
    height: 15.8816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.585494,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 4.56815,
    y: 9.67577,
    width: 8.78279,
    height: 15.9858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.585494,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 19.8211,
    y: 7.95395,
    width: 3.21914,
    height: 4.62259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.292747,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.6634,
    y1: 3.25995,
    x2: 11.6634,
    y2: 27.5294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.8921,
    y1: 3.25999,
    x2: 20.8921,
    y2: 27.5294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 11.6634,
    y1: 3.25995,
    x2: 11.6634,
    y2: 27.5294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.8921,
    y1: 3.25999,
    x2: 20.8921,
    y2: 27.5294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BAF4"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHydrationSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hydration_success_icon.1045a3f8.svg";
export { ForwardRef as ReactComponent };